import { render } from "./EdoDocumentsPage.vue?vue&type=template&id=3775b7ac&scoped=true"
import script from "./EdoDocumentsPage.vue?vue&type=script&lang=js"
export * from "./EdoDocumentsPage.vue?vue&type=script&lang=js"

import "./EdoDocumentsPage.vue?vue&type=style&index=0&id=3775b7ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3775b7ac"]])

export default __exports__